module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre",
    attrs: {
      "id": "pgepubid00009"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('table', {
    staticClass: "calibre13",
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "summary": "Contents"
    }
  }, [_c('tbody', {
    staticClass: "calibre14"
  }, [_c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("chapter")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("page")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("I")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("To the Front")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("II")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Bad News")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("III")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Making Plans")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("IV")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Grace Surprises Her Chums")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0006"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("V")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Problem Solved")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("VI")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Life and Death")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("VII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Race")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("VIII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Red Rags")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("IX")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Thunder and Mud")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("X")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Knight of the Wayside")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XI")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Mystery")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Nearly an Accident")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XIII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Outwitting a Crank")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XIV")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Bluff Point at Last")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XV")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Telegram")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XVI")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Shadow of Disaster")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XVII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Joe Barnes Again")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XVIII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Seriously Wounded")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XIX")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Betty Confesses")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XX")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Missing")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XXI")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Narrow Escape")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XXII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Darkness Before the Dawn")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("197")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XXIII")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Shadow Lifts")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("207")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XXIV")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("His Three Sweethearts")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("217")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre18"
  }, [_vm._v("XXV")]), _vm._v(" "), _c('td', {
    staticClass: "calibre16"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Joy")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre18"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("227")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00010",
      "title": "[1]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_1",
      "title": "[1]"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0